import { RootState } from '../store/store';

export const selectBillingState = (state: RootState) => state.billing;

export const selectCreditPackages = (state: RootState) => state.billing.packages;

export const selectBillingLoading = (state: RootState) => state.billing.isLoading;

export const selectBillingError = (state: RootState) => state.billing.error;

export const selectClientSecret = (state: RootState) => state.billing.clientSecret;

export const selectIsProcessingPayment = (state: RootState) => state.billing.isProcessingPayment;
